import { Link } from "react-router-dom";
import { Printer, ArrowLeft } from "lucide-react";
import { Leaf } from "lucide-react";
import { COPYRIGHT, PrintFooter, BRAND, EDITION } from "@/lib/brand";

export const RecordShell = ({ title, back, children, testId }) => (
  <div className="max-w-4xl mx-auto px-6 lg:px-10 py-10" data-testid={testId}>
    <div className="flex justify-between items-center no-print">
      <button onClick={() => (back ? window.history.back() : null)} className="inline-flex items-center gap-2 text-sm text-stone-500 hover:text-[#2C4A3E]" data-testid="record-back-btn">
        <ArrowLeft className="w-4 h-4" /> Back
      </button>
      <button onClick={() => window.print()} data-testid="record-print-btn"
        className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#2C4A3E] text-white hover:bg-[#1E352B] transition-colors">
        <Printer className="w-4 h-4" /> Print / Save PDF
      </button>
    </div>
    <div className="print-sheet mt-6 rounded-[2rem] bg-white border border-[#E6DEC3] shadow-sm p-8 sm:p-12">
      <div className="flex items-center gap-3 border-b border-[#E6DEC3] pb-5">
        <span className="w-10 h-10 rounded-full bg-[#2C4A3E] grid place-items-center"><Leaf className="w-4 h-4 text-white" /></span>
        <div>
          <p className="font-display text-lg text-[#2C4A3E] leading-tight">{BRAND}</p>
          <p className="text-xs text-stone-500">{EDITION} · Consciousness-based K-12 learning · Georgia Standards of Excellence</p>
        </div>
        <p className="ml-auto font-display text-xl text-[#C87D53]">{title}</p>
      </div>
      {children}
      <p className="mt-10 pt-4 border-t border-[#E6DEC3] text-[10px] text-stone-400 text-center" data-testid="record-copyright">{COPYRIGHT}</p>
    </div>
    <PrintFooter />
  </div>
);

export const LetterBadge = ({ letter, testId }) =>
  letter ? (
    <span data-testid={testId} className={`inline-grid place-items-center w-9 h-9 rounded-full font-display font-semibold ${
      letter === "A" ? "bg-[#6B9080] text-white" : letter === "B" ? "bg-[#E3EBE5] text-[#2C4A3E]" : letter === "C" ? "bg-[#F3DCC9] text-[#8a4b2a]" : "bg-[#F6E1DC] text-red-700"}`}>{letter}</span>
  ) : <span className="text-stone-400">—</span>;

export const RecordLinks = ({ studentId, className = "" }) => (
  <div className={`flex flex-wrap gap-2 ${className}`} data-testid="record-links">
    {[["portfolio", "Self-discovery portfolio"], ["report", "Report card"], ["transcript", "Transcript"], ["enrollment", "Enrollment letter"], ["diploma", "Diploma"], ["accommodations", "IEP / 504"], ["growth", "Growth report"]].map(([p, label]) => (
      <Link key={p} to={`/${p}/${studentId}`} data-testid={`record-link-${p}`}
        className="px-4 py-2 rounded-full border border-[#E6DEC3] bg-white/60 text-sm text-[#2C4A3E] hover:border-[#2C4A3E] transition-colors">{label}</Link>
    ))}
  </div>
);

export const GRADING_SCALE = "Grading scale: A 90-100 · B 80-89 · C 70-79 · F below 70. Averages are based on lesson quiz scores.";
